/**
 * Combines the comparisons within one `requiredWhen` trigger.
 * Values are a persisted config/wire slug.
 *
 * `And` — every comparison must hold; `Or` — at least one must hold.
 */
export enum HaulerRequiredWhenCombinatorEnum {
  And = 'and',
  Or = 'or',
}
